import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiAgent from "../../../core/api/api.agent";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ApiOrderService from "../../../core/api/api.ordersService";
import SelectComponent from "../_Components/ReactSelectComponent";
import { numberRegex, tools } from "../../../core/utils/tools";
import ApiRegion from "../../../core/api/api.region";
import { Checkbox, FormControlLabel } from "@mui/material";

export const CreateAgentModal = ({ createModalAgent, setCreateModalAgent }) => {
  const {
    handleSubmit,
    control,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: { id: 0, isActive: false } });
  const [cities, setCities] = useState([]);
  const [licenseType, setLicenseType] = useState([]);
  const handleClose = () => {
    setCreateModalAgent(false);
  };
  useEffect(() => {
    (async () => {
      try {
        const response = await ApiRegion.getAllCity();
        setCities(response);

        const enumResponse = await ApiOrderService.GetEnumsName("LicenseType");
        const convertedData = enumResponse.data.map((item) => ({ value: item.id, label: item.title }));
        setLicenseType(convertedData);
      } catch (error) {
      }
    })();
    return () => { };
  }, []);

  const onSubmit = async (data) => {
    try {
      // const response = await ApiAgent.updateAgent({ id: data.id, agentApprovalStatus: data.status, discription: data.description });
      data.cityId = +data.cityId.value;
      data.licenseType = +data.licenseType.value;
      if (data.ceoIdentityNumber && !tools.isValidIranNationalId(data.ceoIdentityNumber)) {
        setError("ceoIdentityNumber", { message: "کد ملی نامعتبر است !" })
        throw new Error("ceoIdentityNumber is Invalid !")
      }
      const response = await ApiAgent.createAgent(data);
      if (response.succeeded == true) {
        handleClose();
        document.getElementById("submitButton").click();
        //callBackJustForRunUseEffect();
      }
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  return (
    <div>
      {/* Start Modal */}
      <Modal centered size="md" show={createModalAgent} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title> ایجاد نماینده جدید</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Row>
                <Col xs="12">
                  <Controller
                    name="firstName"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام "
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors.firstName && <div className="mt-2 pl-4 text-danger">**لطفا نام را وارد نمایید</div>}
                </Col>

                <Col xs="12">
                  <Controller
                    name="lastName"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام خانوادگی "
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors.lastName && <div className="mt-2 pl-4 text-danger">**لطفا نام خانوادگی را وارد نمایید</div>}
                </Col>
                <Col xs="12">
                  <Controller
                    name="phoneNumber"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="موبایل"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="companyName"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام شرکت"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors.companyName && <div className="mt-2 pl-4 text-danger">**لطفا نام شرکت را وارد نمایید</div>}
                </Col>

                <Col xs="12">
                  <Controller
                    name="companyNationalId"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="شناسه ملی شرکت"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>

                <Col xs="12">
                  <Controller
                    name="licenseType"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectComponent
                        options={licenseType}
                        placeholder="نوع مجوز شرکت"
                        className="mt-4"
                        name="licenseType"
                        field={field}
                      />
                    )}
                  />
                  {errors.licenseType && <div className="mt-2 pl-4 text-danger">**لطفا مجوز شرکت را وارد نمایید</div>}
                </Col>

                <Col xs="12" className="mt-1">
                  <Controller
                    name="cityId"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectComponent
                        options={cities?.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))}
                        placeholder="نام شهر"
                        field={field}
                        className="mt-5"
                      />
                    )}
                  />
                  {errors.cityId && <div className="mt-2 pl-4 text-danger">**لطفا شهر را وارد نمایید</div>}
                </Col>

                <Col xs="12">
                  <Controller
                    name="address"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="آدرس"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="ceoFirstName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام مدیر عامل"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>

                <Col xs="12">
                  <Controller
                    name="ceoLastName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام خانوادگی مدیر عامل"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="ceoIdentityNumber"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="شماره ملی مدیر عامل"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={(e) => {
                          if (e.target.value && (!numberRegex.test(e.target.value) || e.target.value.length > 10)) {
                            e.target.value = value
                            return
                          }
                          onChange(e)
                        }}
                      />
                    )}
                  />
                  {errors.ceoIdentityNumber && <div className="mt-2 pl-4 text-danger">** گدملی نامعتبر است !</div>}
                </Col>
                <Col>
                  <FormControlLabel
                    control={
                      <Controller
                        control={control}
                        name="isActive"
                        render={({
                          field: { onChange, onBlur, value, ref },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="فعال"
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
